exports = module.exports = require("../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, ".collapsing-pane {\n  width: 100%; }\n  .collapsing-pane > .control-bar {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 1.5rem;\n    padding-left: 0; }\n  .collapsing-pane .content-region {\n    padding-bottom: 1rem; }\n", ""])